module.exports = __webpack_public_path__ + "static/media/rupyIcon.ae8c16a1.svg";